import { Directive, HostListener, Input } from '@angular/core';
import { CopyToClipboard } from '../../lib/copy-to-clipboard';

@Directive({
  selector: '[copy-clipboard]',
  standalone: true,
})
export class CopyClipboardDirective {
  @Input('copy-clipboard')
  public payload: string;

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent): void {
    event.preventDefault();
    if (!this.payload) return;
    CopyToClipboard(this.payload);
  }
}
